import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/(desktop)/rewards/page.tsx");
